var OCS = OCS || {}; //TODO: Build out a means to disable the legend and re-enable it in the new panel when dragged to a new location and have it as a feature of the map
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};

OCS.Viewer.Classes.OverlayMapFeature = new Class({
    init_overlay: function () {
        this.addEvent('layer_group_added', this.on_overlay_layer_group_added.bind(this));
    },
    on_overlay_layer_group_added: function (lg) {
        if (lg && lg.has_overlay) {
            lg.set_overlay(this.add_overlay(this.create_overlay()));
        }
    },
    create_overlay: function () {
        var overlay = new ol.Overlay(/** @type {olx.OverlayOptions} */ ({
            offset: [8, 8]
        }));
        return overlay;
    },
    add_overlay: function (overlay) {
        if (this.ol_object) {
            this.ol_object.addOverlay(overlay);
            overlay.on('change:position', this.on_overlay_position_change.bind(this));
            return overlay;
        }
    },
    on_overlay_position_change: function (e) {
        this.get_overlay_offset(e.target);

    },
    get_overlay_offset: function (overlay) {
        if (!this.get_mouse_position) {
            return;
        }
        var mouse_position = this.get_mouse_position();
        var map = this.get_map();
        var mapSize = map.getSize();
        var containerWidth = mapSize[0];
        var containerHeight = mapSize[1] - 85;
        var pixelPosition = map.getPixelFromCoordinate(mouse_position);
        var xPos = pixelPosition[0];
        var yPos = pixelPosition[1];
        var RightEdge = xPos + 265;
        var BottomEdge = yPos + 165;
        var offset_x = 'right';
        var offset_y = 'bottom';

        if (RightEdge > containerWidth) {
            offset_x = 'left';
        }

        if (BottomEdge > containerHeight) {
            offset_y = 'top';
        }
        var offsets = [offset_x, offset_y];
        var popupElement = overlay.getElement();
        var popupHeight = jQuery(popupElement).height();
        var popupOffset = [];

        if (offsets[0] === 'left') {
            popupOffset[0] = -268;
        } else {
            popupOffset[0] = 8;
        }
        if (offsets[1] === 'top') {
            popupOffset[1] = -(popupHeight + 10);
        } else {
            popupOffset[1] = 8;
        }
        overlay.setOffset(popupOffset);
    },
});